import { render, staticRenderFns } from "./s-form-textarea.vue?vue&type=template&id=c13b1ff8"
import script from "./s-form-textarea.vue?vue&type=script&lang=js"
export * from "./s-form-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports